
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/account/password-reset",
      function () {
        return require("private-next-pages/[lang]/account/password-reset.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/account/password-reset"])
      });
    }
  